import React, { useState } from 'react';
import { TrustBadges } from '../components/TrustBadges';
import { LegalModal } from '../components/LegalModal';
import { ExitIntentPopup } from '../components/ExitIntentPopup';
export function BridgePage() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  const OFFER_URL = 'https://trackrq.dailyhomewellness.com/click';
  const handleRedirect = () => {
    window.location.href = OFFER_URL;
  };
  return <div className="min-h-screen bg-white flex flex-col items-center pt-12 md:pt-24 px-4 font-sans" data-id="element-50">
      <div className="max-w-3xl w-full flex flex-col items-center text-center" data-id="element-51">
        {/* Headline */}
        <h1 className="text-xl md:text-[34px] font-bold text-black mb-4 md:mb-8 leading-snug" data-id="element-52">
          The 2026 Bathroom Upgrade Tool Smart Homeowners Are Using Before
          Overpaying a Contractor
        </h1>

        {/* Subheadline */}
        <h2 className="text-base md:text-xl font-bold text-black mb-4 md:mb-6" data-id="element-53">
          Is Your Bathroom 7 Years Or Older?
        </h2>

        {/* Buttons */}
        <div className="flex flex-row gap-3 md:gap-4 mb-4 md:mb-6 w-full max-w-2xl" data-id="element-54">
          <a href={OFFER_URL} className="flex-1 py-3 md:py-4 bg-[#43A047] hover:bg-[#388E3C] text-white font-medium text-xl md:text-3xl rounded-md transition-colors text-center inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2" data-id="element-55">
            Yes
          </a>
          <a href={OFFER_URL} className="flex-1 py-3 md:py-4 bg-[#E53935] hover:bg-[#D32F2F] text-white font-medium text-xl md:text-3xl rounded-md transition-colors text-center inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2" data-id="element-56">
            No
          </a>
        </div>

        {/* Footer Links */}
        <div className="flex flex-row justify-center gap-4 text-xs text-blue-700 mb-2" data-id="element-57">
          <button type="button" onClick={() => setOpenModal('privacy')} className="underline hover:text-blue-900" data-id="element-58">
            Privacy Policy
          </button>
          <button type="button" onClick={() => setOpenModal('terms')} className="underline hover:text-blue-900" data-id="element-59">
            Terms of Service
          </button>
        </div>

        {/* Trust Badges */}
        <TrustBadges data-id="element-60" />
      </div>

      {/* Modals */}
      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Privacy Policy" data-id="element-61">
        <p data-id="element-62">
          <strong data-id="element-63">Last Updated:</strong> January 2025
        </p>
        <p data-id="element-64">
          This Privacy Policy describes how we collect, use, and share your
          personal information when you visit or interact with this website. By
          using the site, you agree to the terms outlined below.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-65">1. Information We Collect</h3>
        <p data-id="element-66">
          We may collect information you provide directly to us, such as your
          name, email address, phone number, ZIP code, and answers to qualifying
          questions. We also automatically collect technical information such as
          your IP address, browser type, device identifiers, and pages you
          visit.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-67">
          2. How We Use Your Information
        </h3>
        <p data-id="element-68">
          Your information is used to connect you with relevant service
          providers, improve our website, and send you communications about
          offers you may be interested in. We may share your information with
          trusted third-party partners who provide the services you have
          requested.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-69">3. Cookies and Tracking</h3>
        <p data-id="element-70">
          We use cookies, pixels, and similar tracking technologies to measure
          performance, personalize content, and deliver targeted advertising.
          You may disable cookies in your browser settings, but some features of
          the site may not function properly as a result.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-71">4. Your Rights</h3>
        <p data-id="element-72">
          Depending on your jurisdiction, you may have the right to access,
          correct, or delete the personal information we hold about you, and to
          opt out of certain uses of your data. To exercise these rights,
          contact us using the information provided below.
        </p>
      </LegalModal>

      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Terms of Service" data-id="element-73">
        <p data-id="element-74">
          <strong data-id="element-75">Last Updated:</strong> January 2025
        </p>
        <p data-id="element-76">
          These Terms of Service ("Terms") govern your use of this website. By
          accessing or using the site, you agree to be bound by these Terms. If
          you do not agree, please discontinue use of the site.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-77">1. Eligibility</h3>
        <p data-id="element-78">
          You must be at least 18 years of age and a legal resident of the
          United States to use this site. By using the site, you represent and
          warrant that you meet these requirements.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-79">2. Use of the Site</h3>
        <p data-id="element-80">
          You agree to use the site only for lawful purposes and in a manner
          that does not infringe the rights of any third party. You may not use
          the site to transmit any unlawful, harmful, threatening, abusive, or
          otherwise objectionable content.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-81">3. Advertorial Notice</h3>
        <p data-id="element-82">
          This website is an advertorial and not a news publication. Content is
          provided for informational purposes and may include promotional
          material about third-party products and services.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-83">4. Disclaimer of Warranties</h3>
        <p data-id="element-84">
          The site and all content are provided "as is" without warranties of
          any kind, either express or implied. We do not guarantee the accuracy,
          completeness, or reliability of any content on the site.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-85">5. Limitation of Liability</h3>
        <p data-id="element-86">
          To the maximum extent permitted by law, we shall not be liable for any
          indirect, incidental, special, or consequential damages arising out of
          or related to your use of the site.
        </p>
        <h3 className="font-bold text-gray-900" data-id="element-87">6. Changes to These Terms</h3>
        <p data-id="element-88">
          We may update these Terms from time to time. Any changes will be
          posted on this page with an updated revision date. Continued use of
          the site after changes constitutes acceptance of the revised Terms.
        </p>
      </LegalModal>

      {/* Exit Intent Popup */}
      <ExitIntentPopup href={OFFER_URL} data-id="element-89" />
    </div>;
}